// ############################################################
/**
 * Contains the model to hold the events (and perform migrations
 * if it comes the case)
 */
// ############################################################

import { getUserFullName } from '../../helpers/helpers'

import { IModelBaseModel } from '../model-base/model-base.interface'
import { ModelBaseModel } from '../model-base/model-base.model'
import { IGuestInterface } from './guest.interface'

// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
/**
 * Holds the models to store events
 */

export class GuestModel extends ModelBaseModel<IGuestInterface> implements IModelBaseModel {
  public v: number
  public id: string
  public fullName: IGuestInterface['fullName']
  public userEmail: IGuestInterface['userEmail']
  public userName: IGuestInterface['userName']
  public userNameNGram: IGuestInterface['userNameNGram']
  public userFirstName: IGuestInterface['userFirstName']
  public userLastName: IGuestInterface['userLastName']
  public userAddress: IGuestInterface['userAddress']
  public created: IGuestInterface['created']
  public modified: IGuestInterface['modified']

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * Constructs an instance of the class with an object that adheres to the
   * IUserInterface interface
   *
   * @param obj
   * Object that adheres to the IUserInterface interface
   */
  public constructor(obj?: IGuestInterface) {
    super()
    this.v = obj?.v ?? 1
    this.id = obj?.id ?? ''
    this.fullName = obj?.fullName ?? null
    this.userEmail = obj?.userEmail ?? null
    this.userName = !!obj?.userName ? (obj.userName?.toLocaleLowerCase?.() ?? obj?.userName) : null
    this.userFirstName = obj?.userFirstName ?? null
    this.userLastName = obj?.userLastName ?? null
    this.userAddress = obj?.userAddress ?? null
    this.userNameNGram =
      obj?.userNameNGram ?? this.calculateUsernameNGrams(obj ? getUserFullName(obj) : '')

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created as Date,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified as Date,
    })
  }

  static fromFirestoreDoc(doc: any) {
    return new GuestModel({
      id: doc.id,
      ...doc.data(),
    })
  }
}
